export default __webpack_public_path__ + "static/media/Tabela_Descontos_Ilhabela.e68c17e4.pdf";